
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { routeName } from '@/constants/route.constants';
import AuthenticationModule from '@/store/modules/authentication.module';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';

const authModule: AuthenticationModule = getModule(AuthenticationModule, store);

@Component({
  computed: {
    routeName(): typeof routeName {
      return routeName;
    }
  }
})
export default class TagNoMatchComponent extends Vue {
  @Prop({
    default: null
  })
  public code: string;

  public async onRegisterClick() {
    await authModule.tagMatchAction(false);

    this.$router.replace({
      name: routeName.public.register,
      params: {
        tagCode: this.code
      }
    });
  }

  public onHideEvent() {
    this.$router.replace({
      name: routeName.public.scan
    });
  }
}
